<template>
  <!-- 服务商管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='baibuBillCreditList-1'
          >
            <template slot="batch-search-btn">
              <el-button type="primary" :size="formSize" :loading="loading" @click="handleBatchSearch()">
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-col fan-search-right" v-if="$has('BBZQGL-KHSXGL-DC')">
            <page-export-button
              buttonText="导出"
              exportServe="fin_ap_customer_credit"
              :total="total"
              :isLimit="true"
              :exportParams="exportParams"
              trackCode='baibuBillCreditList-5'
            />
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        />
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 启用禁用弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="subAccountObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="setDivideApproval"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='baibuBillCreditList-2'
    />
    <!-- 新增/编辑 -->
    <adjust-limit-dialog
      :visible.sync="isAdjustLimitShow"
      :currentRow="currentRow"
      @success="getList"
    />
  </div>
</template>

<script>
import { getCustBopList, setCustSwitch } from '@/api/baibu-bill';
import { setStatusColor } from '@/filters/index';
import adjustLimitDialog from './components/adjust-limit-dialog';

const queryFormDefault = {
  timeType: '1', // 时间类型
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  cityNo: '', // 归属城市
  creditStatus: '', // 授信状态 ON=正常;OFF=已停用
  searchContent: '', // 搜索内容-不支持模糊查询,批量查询时以逗号分隔
  searchType: '1', // 搜索类型：1-客户名称,2-客户编号,3-财务客户编号

  searchBatchContent: '', // 处理批量查询时-搜索内容
  searchBatchType: '1', // 处理批量查询时-搜索类型
};

export default {
  name: 'BaibuBillCreditList',
  components: { adjustLimitDialog },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '授信时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            { value: '1', label: '客户名称' },
            { value: '2', label: '客户编号' },
            { value: '3', label: '财务客户编号' },
          ],
        },
      ],
      selectList: [
        {
          title: '授信状态',
          prop: 'creditStatus',
          dictionaryPath: '/finance/finance-receipt/CreditStatus',
        },
        {
          title: '归属城市',
          prop: 'cityNo',
          dictionaryPath: '/finance/finance-receipt/CreditCity',
        },
      ],
      tableColumn: [
        { prop: 'customerNo', label: '财务客户编号', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'cityName', label: '归属城市', minWidth: '1' },
        { prop: 'creditQuota', label: '总授信额度(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'payQuota', label: '已支用额度(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'remainingQuota', label: '剩余额度(元)', filterName: 'toFenThousandsAndFloat' },
        // ON=正常;OFF=已停用
        { label: '授信状态', status: 'creditStatus', statusDesc: 'creditStatusDesc', statusColor: (val) => setStatusColor(val, 'creditStatus') },
        { prop: 'createTime', label: '授信时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          label: '操作',
          prop: 'operate',
          width: '140px',
          disabled: true,
          btnGroups: [
            {
              name: '启用',
              plain: true,
              className: ['table-button', 'table-button-success'],
              icon: 'el-icon-success',
              trackCode: 'baibuBillCreditList-3',
              showBtn: (row) => this.$has('BBZQGL-KHSXGL-QY') && row.creditStatus === 'OFF',
              click: (row) => this.handleOperateState('ON', row),
            },
            {
              name: '禁用',
              plain: true,
              className: ['table-button', 'table-button-danger'],
              icon: 'el-icon-error',
              trackCode: 'baibuBillCreditList-4',
              showBtn: (row) => this.$has('BBZQGL-KHSXGL-JY') && row.creditStatus === 'ON',
              click: (row) => this.handleOperateState('OFF', row),
            },
            {
              name: '调额',
              plain: true,
              className: ['table-button', 'table-button-primary'],
              trackCode: 'baibuBillQuotaList-2',
              showBtn: (row) => this.$has('BBZQGL-KHSXGL-TE') && row.creditStatus === 'ON',
              click: (row) => this.handleAdjustLimit(row),
            },
          ],
        },
      ],

      /** ------启用禁用操作-------- */
      isOperateStateShow: false, // 启用禁用弹窗
      submitLoading: false,
      textConfig: {}, // 弹窗页面提示文案
      subAccountObj: {}, // 启用禁用对象


      /** ------调额操作-------- */
      isAdjustLimitShow: false,
      currentRow: {},

      /** ------批量搜索开始---- */
      // 批量搜索搜索条件集合
      batchSearchTypeList: [
        { value: '2', label: '客户编号' },
        { value: '3', label: '财务客户编号' },
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      isBatch: false, // 是否是批量操作
      /** ------批量搜索结束---- */
    };
  },
  computed: {
    exportParams() {
      const params = this.newAPiParam();
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    handleAdjustLimit(row = {}) {
      this.isAdjustLimitShow = true;
      this.currentRow = { ...row };
    },
    // 启用禁用操作请求接口
    async setDivideApproval(params) {
      try {
        this.submitLoading = true;
        console.log(params);
        await setCustSwitch(params);
        this.$message({ message: '操作成功！', type: 'success' });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.handleSearch();
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
    /**
     * 打开启用禁用弹窗
     * customerNo  财务客户编号
     * operate     操作（ON-启用，OFF-停用）
    */
    handleOperateState(operate, row) {
      this.subAccountObj = {
        customerNo: row.customerNo,
        operate,
      };
      const list = {
        ON: {
          title: '人工确认',
          messageTip: '是否【启用】该客户的授信额度？',
          isPass: true,
        },
        OFF: {
          title: '人工确认',
          messageTip: '是否【禁用】该客户的授信额度？',
          isPass: true,
        },
      };
      this.textConfig = list[operate] || '-';
      this.isOperateStateShow = true;
    },

    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = JSON.parse(JSON.stringify(queryFormDefault));
      param.searchBatchType = form.searchType || '';
      param.searchBatchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList(true);
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 处理提交接口的参数（列表/导出）
    newAPiParam() {
      const params = JSON.parse(JSON.stringify(this.queryForm));
      // 批量查询条件处理
      if (this.isBatch) {
        params.searchContent = params.searchBatchContent || '';
        params.searchType = params.searchBatchType || '';
      }
      delete params.timeType;
      delete params.searchBatchContent;
      delete params.searchBatchType;
      return params;
    },
    // 列表接口请求
    async getList(batch = false) {
      try {
        this.isBatch = batch;
        const params = this.newAPiParam();
        this.loading = true;
        this.list = [];
        const res = await getCustBopList(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
